// To generate a new file similar to this one, run `pay js:run gql-v1 --type=query --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

import {gql} from '@sail/data';
import {useV1Query} from '@stripe-internal/data-v1';

import type {GraphQlDocument} from '@sail/data';

import type {
  AccountToken,
  V1QueryOptions,
  V1QueryOptionsWithoutVariables,
  V1QueryReturn,
} from '@stripe-internal/data-v1/types';
import type {
  Exact,
  OpenapiGetV1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSessionInput,
  V1ContextInput,
  OpenapiCryptocurrencyPayinsResourceReturnDetailsCollectionSessionNetworkEnum,
  OpenapiCryptocurrencyPayinsResourceReturnDetailsCollectionSessionStateEnum,
  OpenapiCryptocurrencyPayinsResourceReturnDetailsCollectionSessionCryptocurrencyEnum,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  query RetrieveReturnDetailsCollectionSessionQuery(
    $input: OpenapiGetV1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSessionInput!
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSession(
      input: $input
      v1Context: $v1Context
    ) {
      id
      buttonColor: button_color
      cryptocurrency
      logo
      merchantName: merchant_name
      network
      state
      submittedWalletAddress: submitted_wallet_address_redacted
    }
  }
`;

export const retrieveReturnDetailsCollectionSessionQuery: RetrieveReturnDetailsCollectionSessionQueryDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const retrieveReturnDetailsCollectionSessionQueryOptions: V1QueryOptionsWithoutVariables<RetrieveReturnDetailsCollectionSessionQueryDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function useRetrieveReturnDetailsCollectionSessionQuery(
  options: V1QueryOptions<RetrieveReturnDetailsCollectionSessionQueryDocument>,
): V1QueryReturn<RetrieveReturnDetailsCollectionSessionQueryDocument> {
  return useV1Query(retrieveReturnDetailsCollectionSessionQuery, {
    ...retrieveReturnDetailsCollectionSessionQueryOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type RetrieveReturnDetailsCollectionSessionQueryVariables = Exact<{
  input: OpenapiGetV1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSessionInput;
  v1Context: V1ContextInput;
}>;

export type RetrieveReturnDetailsCollectionSessionQueryData = {
  readonly __typename: 'Query';
  readonly v1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSession: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceReturnDetailsCollectionSession';
    readonly id: string;
    readonly cryptocurrency: OpenapiCryptocurrencyPayinsResourceReturnDetailsCollectionSessionCryptocurrencyEnum | null;
    readonly logo: string | null;
    readonly network: OpenapiCryptocurrencyPayinsResourceReturnDetailsCollectionSessionNetworkEnum;
    readonly state: OpenapiCryptocurrencyPayinsResourceReturnDetailsCollectionSessionStateEnum;
    readonly buttonColor: string | null;
    readonly merchantName: string;
    readonly submittedWalletAddress: string | null;
  } | null;
};

export type RetrieveReturnDetailsCollectionSessionQueryToken = AccountToken<{
  Query_v1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSession: true;
}>;

export type RetrieveReturnDetailsCollectionSessionQueryDocument =
  GraphQlDocument<
    RetrieveReturnDetailsCollectionSessionQueryData,
    RetrieveReturnDetailsCollectionSessionQueryVariables,
    RetrieveReturnDetailsCollectionSessionQueryToken
  >;
